module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.form) ? _c('div', _vm._l((_vm.form), function(f, i) {
    return _c('el-form', {
      key: i
    }, _vm._l((f.children), function(fr, ri) {
      return _c('span', {
        key: ri
      }, _vm._l((fr.children), function(fc, ci) {
        return _c('span', {
          key: ci
        }, [_c(f.dataType, _vm._b({
          tag: "component",
          attrs: {
            "type": f.type ? f.type : null,
            "url": f.dataType === 'file-upload' ? (f.url ? f.url : null) : null
          },
          model: {
            value: (f.value),
            callback: function($$v) {
              _vm.$set(f, "value", $$v)
            },
            expression: "f.value"
          }
        }, 'component', f, false))], 1)
      }), 0)
    }), 0)
  }), 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-145c5f90"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/atoms/forms/FormViewer.vue
// module id = 1334
// module chunks = 0